import axios, { getData } from 'lib/axios'

export const downloadBankTextFile = async (time_id) => {
  const response = await axios.get(`admin/payroll/${time_id}/banktxt`)
  return response
}

export const downloadBankCsvFile = async (time_id) => {
  const response = await axios.get(`admin/payroll/${time_id}/bank`, {
    responseType: 'blob',
  })
  return response
}

export const downloadMonthlyReport = async (time_id) => {
  const response = await axios.get(`admin/payroll/${time_id}/monthly-report`, {
    responseType: 'blob',
  })
  return response
}

export const downloadSalaryReportPdf = async (time_id) => {
  const response = await axios.get(`admin/payroll/${time_id}/salary-report-pdf`, {
    responseType: 'blob',
  })
  return response
}

export const downloadPerkesoSocsoEisTextFile = async (time_id) => {
  const response = await axios.get(`admin/payroll/${time_id}/perkeso-combined-txt`, {
    responseType: 'blob',
  })
  return response
}
export const getEisTextFile = async (time_id) => {
  const res = await axios.get(`admin/payroll/${time_id}/eis-txt`)
  return res
}

export const getMaybankEisTextFile = async (time_id) => {
  const res = await axios.get(`admin/payroll/${time_id}/maybank-eis-txt`)
  return res
}

export const getMaybankEpfTextFile = async (time_id) => {
  const res = await axios.get(`admin/payroll/${time_id}/maybank-epf-txt`)
  return res
}

export const getMaybankSocsoTextFile = async (time_id) => {
  const res = await axios.get(`admin/payroll/${time_id}/maybank-socso-txt`)
  return res
}

export const getMaybankTaxTextFile = async (time_id) => {
  const res = await axios.get(`admin/payroll/${time_id}/maybank-tax-txt`)
  return res
}

export const getSocsoTextFile = async (time_id) => {
  const res = await axios.get(`admin/payroll/${time_id}/socso-txt`)
  return res
}

export const getEpfCsvFile = async (time_id) => {
  const res = await axios.get(`admin/payroll/${time_id}/kwsp-csv`)
  return res
}

export const getMtdTextFile = async (time_id) => {
  const res = await axios.get(`admin/payroll/${time_id}/mtd-txt`)
  return res
}
export const getHrdfReport = async (time_id) => {
  const res = await axios.get(`admin/payroll/${time_id}/hrdf-report`, { responseType: 'blob' })
  return res
}

export const getStatutoryReceipt = async (time_id) => {
  const res = await axios.get(`admin/payroll/${time_id}/receipt-download`)
  return res
}

export const postStatutoryReceipt = async (time_id, payload) => {
  const res = await axios.post(`admin/payroll/${time_id}/receipt-upload`, payload)
  return res
}

export const removeStatutoryReceipt = async (time_id, payload) => {
  const res = await axios.post(`admin/payroll/${time_id}/receipt-delete`, payload)
  return res
}

export const downloadAllPayslip = async (time_id) => {
  const response = await axios.get(`admin/payroll/${time_id}/payslip/download/all`, {
    responseType: 'blob',
  })
  return response
}

export const downloadSelectedEmployeePayslip = async ({ time_id, data }) => {
  const res = await axios.post(`admin/payroll/${time_id}/payslip/download`, data, {
    responseType: 'blob',
  })
  return res
}

export const sendAllPayslip = async (time_id) => {
  const res = await axios.get(`admin/payroll/${time_id}/payslip/notify/all`).then(getData)
  return res
}
export const sendSelectedEmployeePayslip = ({ time_id, data }) => {
  return axios.post(`admin/payroll/${time_id}/payslip/notify`, data)
}

export const retrieveHistory = async (year) => {
  return axios.get(`admin/payrollhistory?year=${year}`).then(getData)
}

export const getHistoryYear = async () => {
  return axios.get('admin/year-dropdown').then(getData)
}

export const getUploadedPayslip = async (time_id) => {
  const res = await axios.get(`admin/payroll/${time_id}/payslip`).then(getData)
  return res
}

export const recalculateAndRegeneratePayslip = async ({ time_id, data }) => {
  return axios
    .post(`admin/payroll/${time_id}/payslip/recalculate-regenerate`, data)
    .then(getData)
}

export const reopenPayroll = async (time_id) => {
  return axios.post(`admin/payroll/${time_id}/reopen`, {}).then(getData)
}
